/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heartbeat_Unreachable_BannerInputs */

const en_heartbeat_unreachable_banner = /** @type {(inputs: Heartbeat_Unreachable_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heartbeat unreachable. Your session may be terminated soon if the issue persists.`)
};

const fr_heartbeat_unreachable_banner = /** @type {(inputs: Heartbeat_Unreachable_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heartbeat indisponible. Votre session pourrait être terminée prochainement si le problème persiste.`)
};

const ms_sg2_heartbeat_unreachable_banner = /** @type {(inputs: Heartbeat_Unreachable_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heartbeat tidak dapat dicapai. Sesi anda mungkin ditamatkan tidak lama lagi jika isu berterusan.`)
};

/**
* | output |
* | --- |
* | "Heartbeat unreachable. Your session may be terminated soon if the issue persists." |
*
* @param {Heartbeat_Unreachable_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const heartbeat_unreachable_banner = /** @type {((inputs?: Heartbeat_Unreachable_BannerInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heartbeat_Unreachable_BannerInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_heartbeat_unreachable_banner(inputs)
	if (locale === "fr") return fr_heartbeat_unreachable_banner(inputs)
	return ms_sg2_heartbeat_unreachable_banner(inputs)
});